import { Section } from '@pkdigital/pkd-custom-components';
import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useClientSide } from '../../utils/useClientSide';
import { AdvantagesCards } from '../advantages/AdvantagesCards';

export default function AdvantagesSection() {
  const { t } = useTranslation();
  const isClient = useClientSide();

  return !isClient ? (
    <></>
  ) : (
    <Container>
      <Section className="advantages" headline={t('advantagesSection.title')}>
        <AdvantagesCards />
      </Section>
    </Container>
  );
}
